const cycuPlace = [
  {
    build_id: 6,
    label: '校長室',
    build: '行政大樓',
  },
  {
    build_id: 6,
    label: '副校長室',
    build: '行政大樓',
  },
  {
    build_id: 6,
    label: '秘書室',
    build: '行政大樓',
  },
  {
    build_id: 9,
    label: '推廣教育處',
    build: '真知教學大樓',
  },
  {
    build_id: 5,
    label: '軍訓室',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '校友服務暨資源發展處',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '招生事務處',
    build: '維澈樓',
  },
  {
    build_id: 39,
    label: '體育室',
    build: '體育館',
  },
  {
    build_id: 5,
    label: '教務處',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '學務處',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '總務處',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '人事室',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '會計室',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '研發處',
    build: '維澈樓',
  },
  {
    build_id: 34,
    label: '校牧處',
    build: '全人教育村', // 中棟
  },
  {
    build_id: 33,
    label: '張靜愚紀念圖書館',
    build: '張靜愚紀念圖書館',
  },
  {
    build_id: 9,
    label: '資訊處',
    build: '真知教學大樓',
  },
  {
    build_id: 57,
    label: '產學營運處',
    build: '知行領航館',
  },
  {
    build_id: 5,
    label: '環境保護暨安全衛生中心',
    build: '維澈樓',
  },
  {
    build_id: 5,
    label: '國際暨兩岸教育處',
    build: '維澈樓',
  },
  { // 2024 update
    build_id: 6,
    label: '校務研究暨永續發展處',
    build: '行政大樓',
  },
  {
    build_id: 5,
    label: '職涯發展處',
    build: '維澈樓',
  },
  {
    build_id: 32,
    label: '應用數學系',
    build: '科學館',
  },
  {
    build_id: 32,
    label: '物理學系',
    build: '科學館',
  },
  {
    build_id: 31,
    label: '化學系',
    build: '理學大樓',
  },
  {
    build_id: 32,
    label: '心理學系',
    build: '科學館',
  },
  {
    build_id: 36,
    label: '生物科技學系',
    build: '生物科技館',
  },
  {
    build_id: 22,
    label: '土木工程學系',
    build: '土木館',
  },
  {
    build_id: 24,
    label: '機械工程學系',
    build: '工學館',
  },
  {
    build_id: 24,
    label: '生物醫學工程學系',
    build: '工學館',
  },
  {
    build_id: 24,
    label: '化學工程學系',
    build: '工學館',
  },
  {
    build_id: 36,
    label: '環境工程學系',
    build: '生物科技館',
  },
  {
    build_id: 23,
    label: '工業與系統工程學系',
    build: '莊敬大樓',
  },
  {
    build_id: 10,
    label: '電子工程學系',
    build: '篤信大樓',
  },
  {
    build_id: 11,
    label: '資訊工程學系',
    build: '電學大樓',
  },
  {
    build_id: 11,
    label: '電機工程學系',
    build: '電學大樓',
  },
  {
    build_id: 28,
    label: '企業管理學系',
    build: '自強商學大樓',
  },
  {
    build_id: 28,
    label: '國際經營與貿易學系',
    build: '自強商學大樓',
  },
  {
    build_id: 28,
    label: '會計學系',
    build: '自強商學大樓',
  },
  {
    build_id: 26,
    label: '資訊管理學系',
    build: '資管樓',
  },
  {
    build_id: 28,
    label: '財務金融學系',
    build: '自強商學大樓',
  },
  {
    build_id: 28,
    label: '建築學系',
    build: '建築館',
  },
  {
    build_id: 21,
    label: '室內設計學系',
    build: '室設館',
  },
  {
    build_id: 25,
    label: '商業設計學系',
    build: '商設館',
  },
  {
    build_id: 19,
    label: '地景建築系',
    build: '地景建築館',
  },
  {
    build_id: 34,
    label: '特殊教育學系',
    build: '全人教育村', // 南棟
  },
  {
    build_id: 34,
    label: '應用外國語文學系',
    build: '全人教育村', // 南棟
  },
  {
    build_id: 34,
    label: '應用華語文學系',
    build: '全人教育村', // 南棟
  },
  {
    build_id: 34,
    label: '財經法律學系',
    build: '全人教育村', // 北棟
  },
  {
    build_id: 17,
    label: '機車停車場',
    build: '機車停車場',
  },
  {
    build_id: 32,
    label: '理學院 辦公室',
    build: '科學館',
  },
  {
    build_id: 24,
    label: '工學院 辦公室',
    build: '工學館',
  },
  {
    build_id: 11,
    label: '電機資訊學院 辦公室',
    build: '電學大樓',
  },
  {
    build_id: 27,
    label: '商學院 辦公室',
    build: '管理大樓',
  },
  {
    build_id: 34,
    label: '法學院 辦公室',
    build: '全人教育村',
  },
  {
    build_id: 18,
    label: '設計學院 辦公室',
    build: '設計學院',
  },
  {
    build_id: 34,
    label: '人文與教育學院 辦公室',
    build: '全人教育村',
  },
  { // 2024 add
    build_id: 33,
    label: '數位教育發展處',
    build: '張靜愚紀念圖書館',
  },
  { // 2024 add
    build_id: 57,
    label: '智慧運算與量子資訊學院',
    build: '知行領航館',
  },
  { // 2025 add
    build_id: 57,
    label: '半導體產業學院',
    build: '知行領航館',
  },
];

export default cycuPlace;
